import { render, staticRenderFns } from "./index.vue?vue&type=template&id=17377418&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LabelComponent: require('/srv/rir-platform/tourism/src/tourism-front/components/common/LabelComponent/index.vue').default,ErrorComponent: require('/srv/rir-platform/tourism/src/tourism-front/components/common/ErrorComponent/index.vue').default})
